import { defineComponent as A, useCssModule as K, ref as t, computed as a, watch as P, onMounted as N, onUnmounted as U, createElementBlock as V, openBlock as W, normalizeClass as L, unref as p, createElementVNode as _, mergeProps as j, renderSlot as D, nextTick as f } from "vue";
import F from "../../utils/propValidator.mjs";
import G from "./calculatePlacement.mjs";
import I from "../../utils/mapClasses.mjs";
const J = "cdr-popup", ee = /* @__PURE__ */ A({
  name: "CdrPopup",
  inheritAttrs: !1,
  customOptions: {},
  __name: "CdrPopup",
  props: {
    opened: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      required: !1,
      default: "top",
      validator: (c) => F(c, ["top", "bottom", "left", "right"])
    },
    autoPosition: {
      type: Boolean,
      default: !0
    },
    contentClass: {
      type: String
    }
  },
  emits: {
    closed: null
  },
  setup(c, {
    emit: B
  }) {
    const o = c, R = B, d = K(), r = t(o.position), i = t(void 0), n = t(!1), C = t(void 0), s = t(!o.opened), u = t(null), E = t(null), x = a(() => o.opened || n.value ? `cdr-popup--${r.value}` : ""), z = a(() => i.value ? `cdr-popup--corner-${i.value}` : ""), $ = a(() => o.opened ? "cdr-popup--open" : ""), b = a(() => s.value && !n.value ? "cdr-popup--closed" : ""), S = a(() => n.value ? "cdr-popup--exit" : ""), g = (e) => {
      R("closed", e);
    }, v = (e) => {
      switch (e.key) {
        case "Escape":
        case "Esc":
          g(e);
          break;
      }
    }, m = (e) => {
      f(() => {
        var l;
        e.target !== u.value && !((l = u.value) != null && l.contains(e.target)) && g(e);
      });
    }, T = () => {
      s.value = !1, f(() => {
        var e;
        C.value = (e = u.value) == null ? void 0 : e.getBoundingClientRect(), s.value = !0;
      });
    }, k = () => {
    }, H = () => {
      document.addEventListener("keydown", v), document.addEventListener("click", m);
    }, M = () => {
      r.value = o.position, i.value = void 0, o.autoPosition && f(() => {
        var h, y;
        const e = (y = (h = E.value) == null ? void 0 : h.parentElement) == null ? void 0 : y.getBoundingClientRect(), {
          innerHeight: l,
          innerWidth: q
        } = window, w = G(e, C.value, q, l, o.position);
        r.value = w.pos, i.value = w.corner;
      }), s.value = !1, setTimeout(() => {
        H();
      }, 1);
    }, O = () => {
      s.value = !0, document.removeEventListener("keydown", v), document.removeEventListener("click", m), n.value = !0, setTimeout(() => {
        n.value = !1;
      }, 200);
    };
    return P(() => o.position, () => r.value = o.position), P(() => o.opened, () => {
      o.opened ? M() : O();
    }), N(() => {
      T(), window.addEventListener("resize", k);
    }), U(() => {
      document.removeEventListener("keydown", v), document.removeEventListener("click", m), window.removeEventListener("resize", k);
    }), (e, l) => (W(), V("div", {
      ref_key: "rootEl",
      ref: E,
      class: L(p(I)(p(d), J, $.value, S.value, x.value, z.value, b.value))
    }, [_("div", j(e.$attrs, {
      class: [p(d)["cdr-popup__content"], c.contentClass],
      ref_key: "popupEl",
      ref: u
    }), [D(e.$slots, "default")], 16), _("div", {
      class: L(p(d)["cdr-popup__arrow"])
    }, null, 2)], 2));
  }
});
export {
  ee as default
};
